import sx from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import variant from '@styled-system/variant';
import styled from '../styled';
import { Theme } from '../theme';
import { STYLE } from './shared';
import Base, { ButtonProps } from './base';

type ButtonVariants = 'default' | 'primary' | 'alt';

const Button = styled(Base, { shouldForwardProp })<ButtonProps<ButtonVariants>>(
  ({ disabled = false }) => {
    return sx({
      color: 'white',
      ...STYLE(disabled),
    });
  },
  variant({
    variants: {
      default: {
        backgroundColor: 'gray.0',
        '&:hover': {
          backgroundColor: 'black',
        },
        '&:active': {
          boxShadow: (theme: Theme) =>
            `inset 0 0 0 1px ${theme.colors.gray[0]}`,
          backgroundColor: 'gray.1',
        },
      },
      primary: {
        backgroundColor: 'red.3',
        '&:hover': {
          backgroundColor: 'red.2',
        },
        '&:active': {
          boxShadow: (theme: Theme) => `inset 0 0 0 1px ${theme.colors.red[1]}`,
        },
      },
      alt: {
        backgroundColor: 'gray.6',
        color: 'gray.0',
        '&:hover': {
          backgroundColor: 'gray.5',
        },
        '&:active': {
          boxShadow: (theme: Theme) =>
            `inset 0 0 0 1px ${theme.colors.gray[4]}`,
        },
      },
    },
  }),
);

Button.defaultProps = {
  variant: 'default',
  size: 'md',
  disabled: false,
};

Button.displayName = 'Monterey(Button)';

export default Button;
